module.exports = __webpack_public_path__ + "static/media/pin.c50539cc.svg";